import React, {useMemo} from "react"

import {BrandAvatarProps} from "@irati/ui/src/BrandAvatar"
import GradientOverlay from "@irati/ui/src/GradientOverlay"
import {resizeCloudinaryImage} from "@irati/utils/images"
import {StyledItemAvatar} from "./styled"

export type ItemAvatarProps = BrandAvatarProps & {
  src: string
  withOverlay?: boolean
}

const ItemAvatar = ({src, withOverlay = true, ...props}: ItemAvatarProps) => {
  const resizedImgUrl = useMemo(() => resizeCloudinaryImage(src, 140, 140), [])

  return (
    <div style={{position: "relative"}}>
      {withOverlay && <GradientOverlay gradientType="linear" />}
      <StyledItemAvatar src={resizedImgUrl} {...props} />
    </div>
  )
}

export default ItemAvatar
